import { Option } from 'fp-ts/lib/Option';
import { useEffect, useState } from 'react';
import { RemoteData } from '../RemoteData';
import getHelpAndGuidanceResults from './getHelpAndGuidanceResults';
import { HelpAndGuidanceResult } from './types';

type ResultState = RemoteData<HelpAndGuidanceResult[]>;

export default function useHelpAndGuidanceResults({
  q,
  countryCode,
}: {
  q: Option<string>;
  countryCode: Option<string>;
}): ResultState {
  const [results, setResults] = useState<ResultState>({ type: 'idle' });

  useEffect(() => {
    if (q.isNone() || countryCode.isNone()) {
      setResults({ type: 'idle' });
      return;
    }

    let cancelled = false;

    setResults({ type: 'loading' });

    (async () => {
      try {
        const data = await getHelpAndGuidanceResults(
          q.value,
          countryCode.value
        );
        if (!cancelled) {
          setResults({
            type: 'loaded',
            data,
          });
        }
        return;
      } catch (error) {
        if (!cancelled) {
          setResults({ type: 'error', error });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [q, countryCode]);

  return results;
}
